<template>
    <div class="p-3">
        orders
    </div>
</template>

<script>
export default {
    name: "OrderForms",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
